/* eslint-disable react/no-unstable-nested-components */

import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {useVehicleAppraiserAnalyticsTrack} from '../../hooks/useVehicleAppraiserAnalyticsTrack.js'

const BASE_CLASS = 'mt-VehicleAppraiserPage-particularSellerBenefits'

const ParticularSellerBenefits = ({
  bodyTypeDoors,
  fuelId,
  km,
  makeId,
  modelId,
  roundedRecommendPrice,
  transmissionTypeId,
  versionId,
  year
}) => {
  const imageClassName = `${BASE_CLASS}-image`

  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const router = useRouter()

  const {trackOnClickPublishButton} = useVehicleAppraiserAnalyticsTrack()

  const urlStaticImages = config.get('URL_STATICS_IMAGES')
  const appName = config.get('APP_NAME').toLowerCase()
  const urlInstantOfferImages = `${urlStaticImages}${appName}/landing/instant-offer/`

  const cards = [
    {
      image: {
        alt: i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.CARDS.GREAT_VISIBILITY.IMAGE_ALT'),
        src: `${urlInstantOfferImages}product-visibility.svg`
      },
      title: i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.CARDS.GREAT_VISIBILITY.TITLE'),
      description: i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.CARDS.GREAT_VISIBILITY.DESCRIPTION')
    },
    {
      image: {
        alt: i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.CARDS.YOUR_AD_IN_ONE_MINUTE.IMAGE_ALT'),
        src: `${urlInstantOfferImages}pta.svg`
      },
      title: i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.CARDS.YOUR_AD_IN_ONE_MINUTE.TITLE'),
      description: i18n.t(
        'LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.CARDS.YOUR_AD_IN_ONE_MINUTE.DESCRIPTION'
      )
    },
    {
      image: {
        alt: i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.CARDS.PUBLISH_SAFELY.IMAGE_ALT'),
        src: `${urlInstantOfferImages}about-my-data.svg`
      },
      title: i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.CARDS.PUBLISH_SAFELY.TITLE'),
      description: i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.CARDS.PUBLISH_SAFELY.DESCRIPTION')
    }
  ]

  const handleOnClickPublishButton = async () => {
    const trackPromise = trackOnClickPublishButton()

    const obtainDraftPromise = domain.get('obtain_draft_ad_publisher_use_case').execute()

    const [
      {
        value: [draftError, draftResponse]
      }
    ] = await Promise.allSettled([obtainDraftPromise, trackPromise])

    if (!draftError) {
      const {
        data: {id: adId}
      } = draftResponse

      const fields = {
        bodyTypeDoors,
        fuelId,
        km,
        makeId,
        modelId,
        price: roundedRecommendPrice ? roundedRecommendPrice.toString() : null,
        publishInMA: true,
        transmissionTypeId,
        versionId,
        year
      }

      await domain.get('edit_draft_ad_publisher_use_case').execute({
        fields,
        adId
      })
    }

    const {PUBLISH_MY_AD_PATH_PATTERN} = domain.get('config').get('page')
    router.push(PUBLISH_MY_AD_PATH_PATTERN)
  }

  return (
    <div className={BASE_CLASS}>
      <TitleBasic
        as={titleBasicTags.h2}
        size={titleBasicSizes.s}
        title={i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.TITLE')}
      />
      <div className={`${BASE_CLASS}-cards`}>
        {cards.map((card, index) => {
          const {
            description: cardDescription,
            image: {alt: imageAlt, src: imageSrc},
            title: cardTitle
          } = card

          return (
            <div key={`${cardTitle}${index}`}>
              <div className={imageClassName}>
                <img src={imageSrc} alt={imageAlt} width={90} />
              </div>
              <TitleBasic as={titleBasicTags.h3} size={titleBasicSizes.xss} title={cardTitle} />
              {cardDescription ? <p className={`${BASE_CLASS}-cardItemDescription`}>{cardDescription}</p> : null}
            </div>
          )
        })}
      </div>

      <AtomButton
        onClick={handleOnClickPublishButton}
        design={atomButtonDesigns.PRIMARY}
        shape={atomButtonShapes.CIRCULAR}
        size={atomButtonSizes.LARGE}
      >
        {i18n.t('LANDING_VEHICLE_APPRAISER.PARTICULAR_SELLER_BENEFITS.PUBLISH_AD_BUTTON_TEXT')}
      </AtomButton>
    </div>
  )
}

ParticularSellerBenefits.displayName = 'ParticularSellerBenefits'
ParticularSellerBenefits.propTypes = {
  bodyTypeDoors: PropTypes.string,
  fuelId: PropTypes.string,
  km: PropTypes.number,
  makeId: PropTypes.string,
  modelId: PropTypes.string,
  roundedRecommendPrice: PropTypes.number,
  transmissionTypeId: PropTypes.string,
  versionId: PropTypes.string,
  year: PropTypes.number
}

export default ParticularSellerBenefits
